export * from './RoomsPaywall';
export { MaxRoomsPaywall } from '~teacher/components/rooms/RoomsPaywall/ShortRoomsPaywall';
